import DateFnsUtils from '@date-io/date-fns'
import { yupResolver } from '@hookform/resolvers'
import { UploadPreview } from '@ifca-root/react-component/src/components/Avatar/UploadPreview'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { VoiceTextField } from '@ifca-root/react-component/src/components/Input/CustomTextField'
import { FileUploadInput } from '@ifca-root/react-component/src/components/Input/FileUploadInput'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { amtStr } from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter'
import useUploadAttachment from '@ifca-root/react-component/src/utils/hooks/useUploadAttachment'
import {
  Checkbox,
  CircularProgress,
  Grid,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
} from '@material-ui/core'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import { Autocomplete } from '@material-ui/lab'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import { TooltipAmountFooter } from 'components/Footer/TooltipAmountFooter'
import { FormAllocationTableContent } from 'components/Table/FormAllocationTableContent'
import { useAPCreateUpdateMutation } from 'containers/APModule/Hooks/useAPCreateUpdateMutation'
import { ItemDialog } from 'containers/APModule/components/ItemDialog'
import { ItemDetail } from 'containers/ARAPModule/Components/Detail/ItemDetail'
import { IsEinvoiceSelfBilled } from 'containers/ARAPModule/Components/Dialog/EInvoiceComponent/SelfBilledComponent'
import { statusInput } from 'containers/ARAPModule/Function/DocumentChecker'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  RecordStatus,
  useDocumentListingLazyQuery,
  useGetApAllocationDocumentLazyQuery,
  useGetApValidatedDocRefLazyQuery,
  useGetCompanyNameQuery,
  useGetCostCentreLazyQuery,
  useGetCreditorAccountCompanyAssignmentPaginatedListingLazyQuery,
  useGetDebtorAccountListingQuery,
  useGetDocNumTitleQuery,
  useGetDocumentDateValidationQuery,
  useGetEInvoiceCompanyStartLazyQuery,
  useGetExpenseItemLazyQuery,
  useGetGeneralGrtnLazyQuery,
  useGetGrtnItemLazyQuery,
  useGetMsicCodeQuery,
  useGetSalesOrderByDebtorLazyQuery,
  useLatestOpenPeriodCheckingDateQuery,
} from 'generated/graphql'
import { handleExitConfirmation } from 'helpers/Form/ExitConfirmation'
import { CommonYupValidation } from 'helpers/Form/YupValidation'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import {
  formatDashDate,
  formatDate,
} from 'helpers/StringNumberFunction/FormatDate'
import React, { Fragment, useContext, useEffect, useState } from 'react'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import * as yup from 'yup'
import AuditLog from 'assets/icons/MFRS16/auditlog.svg'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
import InfiniteScroll from 'react-infinite-scroll-component'
import { PaginatedAutocomplete } from '@ifca-root/react-component/src/containers/ComponentModule/PaginatedAutoComplete'
interface CreditNoteProps {
  DocDate: string
  einvoice_self_billed_date: string
  TrxDate: string
  DocAmt: number
  Remark: string
  Description: string
  approval: string
  user: string
  CreditorAccountID: string
  CreditDebitID: string
  GRTNHeaderID: string
  ExpenseItemID: string
  RefNo: string
  CompanyID: string
  MSICCodeID: string
  isSelfBilled: boolean
  isRefundNote: boolean
  TaxRate: number
  TaxSchemeID: string
  DocNo: string
  UIN: string
  Allocation: any[]
  DocRefID: any[]
}

export const CreditNoteFormWithAllocation = (props: any) => {
  const { formMode, docType } = props
  const { CompanyID, ID }: any = useParams()
  const [taxEffectiveList, setTaxEffectiveList] = useState<any>()
  const [detailMode, setDetailMode] = useState('')
  // Expense Item
  const [totalLength, setTotalLength] = useState(0)
  const [expenseItemListing, setExpenseItemListing] = useState([])

  /* -------------------------------------------- */
  /*                   VARIABLES                  */
  /* -------------------------------------------- */

  let form, mode
  switch (formMode) {
    case 'add':
      form = 'New'
      mode = 'add'
      break
    case 'edit':
      form = 'Draft'
      mode = 'edit'
      break
    case 'approve-reject':
      form = 'Approve'
      mode = 'approve-reject'
      break
    case 'resubmit':
      form = 'Resubmit'
      mode = 'edit'
      break
  }

  let history = useHistory()
  let location = useLocation()
  const editData = location?.state as any

  /* -------------------------------------------- */
  /*                     STATE                    */
  /* -------------------------------------------- */
  const [selectedTax, setSelectedTax] = useState(null)

  const { setOpenSnackBar, setSnackBarMsg } = useContext(SnackBarContext) as any

  const [openItemDialog, setOpenItemDialog] = useState<boolean>(false)
  const [openExitConf, setOpenExitConf] = useState(null)
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')
  const [initDocs, setInitDocs] = useState([])
  useEffect(() => {
    if (editData?.Attachment) {
      setInitDocs(editData?.Attachment)
    }
  }, [editData])

  const [creditNoteItemData, setCreditNoteItemData] = useState([])
  const [edit, setEdit] = useState(false)
  const [record, setRecord] = useState(false)
  const [voiceRemark, setVoiceRemark] = useState('')

  const [isSubmit, setIsSubmit] = useState(false)
  const [skip, setSkip] = useState(0)
  const take = 20
  const [hasMore, setHasMore] = useState(true)
  const [selectedDocs, setSelectedDocs] = useState<Set<any>>(new Set([]))
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
  const checkedIcon = <CheckBoxIcon fontSize="small" />
  const [creditorAccID, setCreditorAccID] = useState(
    editData ? editData?.CreditorAccountID : null
  )
  const [refresh, setRefresh] = useState(!!editData?.CreditorAccountID)
  const [creditorAccounts, setCreditorAccounts] = useState([])
  const [totalCreditorAccounts, setTotalCreditorAccounts] = useState(0)
  /* -------------------------------------------- */
  /*                   USE FORM                   */
  /* -------------------------------------------- */
  // checking the document number setup

  let refTable, routeSegments, itemRefTable, itemRefTableKey, primaryKey, title
  switch (docType) {
    case 'credit-note':
      routeSegments = 'Debit Adjustment'
      refTable = 'AP_CreditNote'
      itemRefTable = 'APCreditNoteItem'
      itemRefTableKey = 'CreditNoteItemID'
      title = 'Debit Adjustment'
      primaryKey = 'CreditNoteID'
      break
    case 'creditor-credit-note':
      routeSegments = 'Credit Note from Creditor'
      refTable = 'AP_CreditorCreditNote'
      itemRefTable = 'APCreditorCreditNoteItem'
      itemRefTableKey = 'CreditorCreditNoteItemID'
      title = 'Credit Note from Creditor'
      primaryKey = 'CreditorCreditNoteID'
      break

    default:
      break
  }

  const [docNoChecker, setDocNoChecker] = useState(false)

  const {
    loading: docNumHeaderLoading,
    data: { getDocumentNumberHeader } = {
      getDocumentNumberHeader: [],
    },
  } = useGetDocNumTitleQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    variables: { CompanyID, RefTable: refTable },
    onCompleted: ({ getDocumentNumberHeader }) => {
      if (
        (getDocumentNumberHeader?.length > 0 &&
          getDocumentNumberHeader?.find(x => x?.IsAutoDocNo === true)) ||
        getDocumentNumberHeader?.find(x => x?.IsAutoDocNo === true) ||
        (getDocumentNumberHeader?.length === 0 && docType === 'credit-note')
      ) {
        setDocNoChecker(true)
      }
    },
  })

  const {
    loading: openPeriodCheckDateLoading,
    data: { latestOpenPeriodCheckingDate } = {
      latestOpenPeriodCheckingDate: {} as any,
    },
  } = useLatestOpenPeriodCheckingDateQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    variables: { CompanyID },
  })

  //e-invoice setup for transaction
  const [isSelfBilled, setIsSelfBilled] = useState(
    editData ? editData?.einvoice_self_billed : false
  )

  const [isRefundNote, setIsRefundNote] = useState(
    editData ? editData?.einvoice_is_refund_note : false
  )

  const [msicCodeID, setMsicCodeID] = useState(
    editData ? editData?.einvoice_msic_code_id : null
  )

  const CreditNoteFormSchema = yup.object().shape({
    CreditorAccountID: CommonYupValidation.requireField(
      'Creditor Name is required'
    ),
    DocDate: yup.string().required('Doc Date is Required'),
    TrxDate: yup.string().required('Transaction Date is Required'),
    Description: CommonYupValidation.requireField(SystemMsgs.description()),
    ...(docNoChecker === false && docType === 'creditor-credit-note'
      ? {
          DocNo: yup
            .string()
            .required('Document No. is Required')
            .matches(
              /^(?!\s*$).+/,
              'Entry invalid as field contains space only'
            ),
        }
      : null),
    ...(isSelfBilled
      ? {
          MSICCodeID: yup.string().when('isSelfBilled'.toString(), {
            is: true,
            then: yup.string().required(SystemMsgs.MSICCode()),
            otherwise: msicCodeID,
          }),
        }
      : null),
    ...(isSelfBilled
      ? {
          DocRefID: yup.string().when('isSelfBilled'.toString(), {
            is: true,
            then: yup.string().required('Document Ref. is Required'),
            otherwise: null,
          }),
        }
      : null),
    RefNo: yup.string().required('Reference No is Required'),
  })

  const {
    handleSubmit,
    register,
    setValue,
    control,
    errors,
    reset,
    setError,
    getValues,
    formState,
    watch,
    clearErrors,
    unregister,
  } = useForm<CreditNoteProps>({
    defaultValues: {
      RefNo: editData ? editData?.RefNo : '',
      DocDate: editData ? editData?.DocDate : new Date(),
      Remark: editData ? editData?.Remark : '',
      Description: editData ? editData?.Description : '',
      CreditorAccountID: editData ? editData?.CreditorAccountID : '',
      UIN: editData ? editData?.einvoice_irbm_unique_id : '',
      // MSICCodeID: editData ? editData?.einvoice_msic_code_id : msicCodeID,
      isSelfBilled: editData ? editData?.einvoice_self_billed : null,
    },
    mode: 'onSubmit',
    resolver: yupResolver(CreditNoteFormSchema),
  })

  const { anchorEl, menu, handleClick, handleClose, resetMenu } =
    useMenuOption()

  // Upload Document
  const {
    files,
    setFiles,
    setPreviewFiles,
    handleUploadChange,
    previewFiles,
    remove: removeFile,
    handleEditUpload,
  } = useUploadAttachment()

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */
  let docDate = watch('DocDate') ? new Date(watch('DocDate')) : null

  // Company Name
  const {
    loading: CompanyLoading,
    data: { getCompany: curCompany } = { getCompany: [] },
  } = useGetCompanyNameQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
      RecordStatus: RecordStatus.Active,
    },
    onCompleted: ({ getCompany }) => {
      fetchEinvComp({
        variables: {
          CompanyID: CompanyID,
          RecordStatus: RecordStatus.Active,
          DocDate: !!watch('DocDate') ? docDate : new Date(),
        },
      })
    },
  })

  const [
    fetchSalesOrder,
    {
      loading: SalesOrderLoading,
      data: { getSalesOrderByDebtor } = { getSalesOrderByDebtor: [] },
    },
  ] = useGetSalesOrderByDebtorLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrorDia(true)
      setErrMsg(error)
    },
  })

  const {
    loading: DebtorAccountLoading,
    data: { getDebtorAccountListing } = { getDebtorAccountListing: [] },
  } = useGetDebtorAccountListingQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrorDia(true)
      setErrMsg(error)
    },
    onCompleted: () => {
      if (editData) {
        fetchSalesOrder({
          variables: {
            DebtorAccountID: menu?.obj?.DebtorAccountID,
            excludeSalesOrderID: menu?.obj?.SalesOrderID,
          },
        })
      }
    },
  })

  const [
    fetchEinvComp,
    {
      loading: EinvCompStartLoading,
      data: { getCompany: curEinvCompStart } = { getCompany: [] },
    },
  ] = useGetEInvoiceCompanyStartLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
      RecordStatus: RecordStatus.Active,
      DocDate: !!watch('DocDate') ? docDate : new Date(),
    },
    onCompleted: ({ getCompany }) => {
      setIsEinvoice(curEinvCompStart[0]?.EInvoiceStarted)
      setIsSelfBilled(
        editData
          ? editData?.einvoice_self_billed
          : curEinvCompStart[0]?.EInvoiceStarted
      )
    },
  })

  const {
    loading: DocDateValidationLoading,
    data: { getDocumentDateValidation } = { getDocumentDateValidation: [] },
  } = useGetDocumentDateValidationQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    onCompleted: () => {},
  })

  // Creditor Account Company Assignment//

  const [
    fetchGetCreditorAccountCompanyAssignmentPaginatedListing,
    {
      loading: FetchGetCreditorAccountCompanyAssignmentPaginatedLoading,
      data: { getCreditorAccountCompanyAssignmentPaginatedListing } = {
        getCreditorAccountCompanyAssignmentPaginatedListing: {},
      },
    },
  ] = useGetCreditorAccountCompanyAssignmentPaginatedListingLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    onCompleted: () => {
      setCreditorAccounts(prev => [
        ...prev,
        ...getCreditorAccountCompanyAssignmentPaginatedListing?.Data.map(
          data => data?.CreditorAccount
        ),
      ])

      setTotalCreditorAccounts(
        getCreditorAccountCompanyAssignmentPaginatedListing?.TotalLength
      )
      setRefresh(false)
    },
    fetchPolicy: 'network-only',
    variables: {
      CompanyID,
      skip: 0,
      take: 50,
    },
  })

  const creditorAcc =
    getCreditorAccountCompanyAssignmentPaginatedListing?.Data?.map(
      (x: any) => x?.CreditorAccount
    ) ?? []

  let selectedCreditor = creditorAcc?.filter(
    x => x?.CreditorAccountID === watch('CreditorAccountID')
  )

  const [isEinvoice, setIsEinvoice] = useState<boolean>(
    editData ? editData?.einvoice_self_billed : false
  )

  let defaultMsicCodeID = creditorAcc?.find(
    x => x?.CreditorAccountID === watch('CreditorAccountID')
  )?.einvoice_msic_code_id

  const {
    loading: msicCodeLoading,
    data: { getMSICCode } = { getMSICCode: [] },
  } = useGetMsicCodeQuery({
    fetchPolicy: 'network-only',
  })

  const [
    fetchValidatedDocRef,
    {
      loading: APValidatedDocRefLoading,
      data: { getAPValidatedDocRef } = { getAPValidatedDocRef: [] },
    },
  ] = useGetApValidatedDocRefLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
  })

  //   For allocation purposes
  const [allocatedObj, setAllocatedObj] = useState({})
  const [
    loadAllocationDocument,
    {
      loading: getAllocationDocumentLoading,
      data: { getAllocationDocument } = { getAllocationDocument: [] },
    },
  ] = useGetApAllocationDocumentLazyQuery({
    fetchPolicy: 'network-only',
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    onCompleted: ({ getAllocationDocument }) => {
      let arr = []
      if (getAllocationDocument?.length > 0) {
        getAllocationDocument?.map((alloc, index) => {
          arr.push({
            AllocationID: alloc?.AllocationID,
            CreditOrDebit: alloc?.CreditOrDebit,
            DocDate: alloc?.DocDate,
            DocNo: alloc?.DocNo,
            Description: alloc?.Description,
            // for previous allocated amt on the same doc
            AllocationAmt: Number(
              allocatedObj[alloc[`${alloc?.CreditOrDebit}ID`]] ?? 0
            ),
            // balance amount + previous allocated amt on the same doc
            BalanceAmt:
              parseFloat(alloc?.BalanceAmt) +
              Number(allocatedObj[alloc[`${alloc?.CreditOrDebit}ID`]] ?? 0),
            // credit or debit id
            [`${alloc?.CreditOrDebit}ID`]: alloc[`${alloc?.CreditOrDebit}ID`],
            // credit or debit ref table
            [`${alloc?.CreditOrDebit}RefTable`]:
              alloc[`${alloc?.CreditOrDebit}RefTable`],
            // credit or debit doc no
            [`${alloc?.CreditOrDebit}DocNo`]:
              alloc[`${alloc?.CreditOrDebit}DocNo`],
            //is einvoice
            // IsEinvoice: alloc?.is_einvoice,
          })

          return alloc
        })

        append(arr)
        setSkip(prev => prev + getAllocationDocument.length)

        // Kalau dapat kurang dari take, maksudnya dah last page
        if (getAllocationDocument.length < take) {
          setHasMore(false)
        }
      } else {
        // Kalau kosong, memang takde lagi data
        setHasMore(false)
      }
    },
  })

  // General GRTN
  const [
    fetchGeneralGRTN,
    {
      data: { getGeneralGRTN } = { getGeneralGRTN: [] },
      loading: GeneralGRTNLoading,
    },
  ] = useGetGeneralGrtnLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
  })

  // Item GRTN
  const [
    fetchGRTNItem,
    { data: { getGRTNItem } = { getGRTNItem: [] }, loading: ItemGRTNsLoading },
  ] = useGetGrtnItemLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    onCompleted: ({ getGRTNItem }) => {
      let arry = []
      if (getGRTNItem?.length > 0) {
        getGRTNItem?.map((el, index) => {
          arry.push({
            GRTNItemID: el?.GRTNItemID,
            ExpenseItemName: el?.ItemName,
            ExpenseItemID: el?.ItemID,
            CostCentreCode: el?.CostCentreCode,
            CostCentreID: el?.CostCentreID,
            Amount: el?.Amount,
            TaxSchemeID: el?.TaxSchemeID,
            TaxCode: el?.TaxCode,
            TaxAmt: el?.TaxAmt,
            Remark: el?.Remark ?? el?.Remarks ?? '-',
            Quantity: Number(parseFloat(el?.Quantity).toFixed(4)),
            UnitPrice: Number(parseFloat(el?.UnitPrice).toFixed(4)),
            UOMID: el?.UOMID,
            DocAmt: el?.Amount + el?.TaxAmt,
            Description: '-',
            einvoice_classification_code_id:
              selectedCreditor[0]?.einvoice_classification_code_id,
            Sequence: index + 1,
            ItemTaxInfo: el?.ItemTaxInfo,
          })
          return el
        })
        setCreditNoteItemData(arry)
      }
    },
  })

  //CostCentre
  const [
    fetchCostCentre,
    {
      loading: CostCentreLoading,
      data: { getCostCentre } = { getCostCentre: [] },
    },
  ] = useGetCostCentreLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
      orderByAsc: 'CostCentreID',
      IsLastNode: true,
    },
  })

  // Item
  const [
    fetchExpenseItem,
    {
      loading: ExpenseItemLoading,
      data: { getItemByCompany } = { getItemByCompany: {} },
    },
  ] = useGetExpenseItemLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
    },
    onCompleted: () => {
      setTotalLength(getItemByCompany?.TotalLength)
      setExpenseItemListing(prev => [
        ...new Set([...prev, ...getItemByCompany?.Data]),
      ])
    },
    fetchPolicy: 'network-only',
    variables: { CompanyID, skip: 0, take: 50 },
  })

  const [fetchDocuments, { loading: documentLoading, data: DocData }] =
    useDocumentListingLazyQuery({
      onError: error => {
        let errorMessage = error.message.substring(15)
        console.log('ERROR', error)
        setErrorDia(true)
        setErrMsg(errorMessage)
      },
      fetchPolicy: 'network-only',
      onCompleted: ({ DocumentListing }) => {
        // only applies when first opening edit form, when editData still does not have "files" but only Attachment from field resolver
        if (!editData?.files) {
          handleEditUpload(
            DocumentListing?.filter(doc => doc?.description !== 'document_pdf')
          )
          previewFiles?.push(
            ...DocumentListing?.filter(
              doc => doc?.description !== 'document_pdf'
            )?.map(x => x?.fileURL)
          )
        } else {
          setFiles(editData?.files)
          setPreviewFiles(
            editData?.files?.map(file => {
              return URL.createObjectURL(file)
            })
          )
        }
      },
    })

  // only applies when first opening edit form, when editData still does not have "files" but only Attachment from field resolver
  // call fetchDocuments to get existing attachment from db
  useEffect(() => {
    if (
      formMode === 'edit' ||
      formMode === 'approve-reject' ||
      formMode === 'resubmit'
    )
      if (!!!editData?.files) {
        fetchDocuments({
          variables: {
            refID: ID,
          },
        })
      }
  }, [formMode])

  useEffect(() => {
    if (editData?.Remark) {
      setValue('Remark', editData?.Remark)
    }
    if (editData?.Allocation) {
      let allocatedArr = editData?.Allocation
      allocatedArr?.map(allocated => {
        if (!(allocated[`${allocated?.CreditOrDebit}ID`] in allocatedObj)) {
          allocatedObj[allocated[`${allocated?.CreditOrDebit}ID`]] =
            allocated?.AllocationAmt
        }
      })
    }
  }, [editData])

  useEffect(() => {
    if (editData?.CreditorAccountID && !!curEinvCompStart) {
      loadAllocationDocument({
        variables: {
          entityID: [ID],
          creditorDebtorID: editData?.CreditorAccountID,
          companyID: CompanyID,
          refTable: refTable,
          skip: 0,
          take: 20,
        },
      })
    }
    if (editData?.CNDocRef.length > 0) {
      fetchValidatedDocRef({
        variables: {
          CompanyID: CompanyID,
          CreditorAccountID: editData?.CreditorAccountID,
        },
      })
      const selected = new Set()
      editData?.CNDocRef?.map(x => {
        selected.add(x?.DocRefID)
      })

      setSelectedDocs(new Set(selected))
      register('DocRefID')
      setValue('DocRefID', Array.from(selected))
      clearErrors('DocRefID')
    }
  }, [allocatedObj, editData])

  /* -------------------------------------------- */
  /*                  MUTATION                    */
  /* -------------------------------------------- */

  const { handleMutation, mutationLoading, mutationCalled } =
    useAPCreateUpdateMutation({
      docType: docType,
      mode: mode,
      CompanyID: CompanyID,
      isSubmit: isSubmit,
      setErrorDia,
      setErrMsg,
    })

  const { fields, append, remove, prepend } = useFieldArray({
    control,
    name: 'Allocation',
  })

  /* -------------------------------------------------- */
  /*                   DOC NO CHECKING                  */
  /* -------------------------------------------------- */

  //checking for existing docNo
  const str = watch('DocNo')

  const existingDocNo = creditorAcc?.find(
    x => x?.CreditorAccountID === watch('CreditorAccountID')
  )?.DocNoList

  const findDuplicates = arr => {
    if (
      (formMode === 'add' && arr?.includes(str)) ||
      (formMode === 'edit' &&
        arr?.filter(x => x !== editData?.DocNo)?.includes(str))
    ) {
      return true
    } else {
      return false
    }
  }

  const checkSetupNumStruc = () => {
    if (
      (getDocumentNumberHeader?.length > 0 &&
        getDocumentNumberHeader?.find(x => x?.IsAutoDocNo === true) &&
        getDocumentNumberHeader[0]?.SampleOutput === '') ||
      (getDocumentNumberHeader
        ?.filter(x => x?.RefTable === 'AP_CreditNote')
        ?.find(y => y?.SampleOutput === '') &&
        docNoChecker === true) ||
      (getDocumentNumberHeader?.length === 0 &&
        docNoChecker === true &&
        docType === 'credit-note')
    ) {
      return true
    } else return false
  }

  /* -------------------------------------------- */
  /*                   FUNCTION                   */
  /* -------------------------------------------- */

  const inputData = (data, status) => {
    return {
      ...(docType === 'creditor-credit-note'
        ? { CreditorCreditNoteID: ID }
        : { CreditNoteID: ID }),
      CompanyID: CompanyID,
      DocDate: formatDashDate(new Date(data?.DocDate)?.toISOString()),
      TransactionDate: formatDashDate(new Date(data?.TrxDate)?.toISOString()),
      DocAmt: totalAmount,
      TaxAmt: totalTaxAmt ?? 0,
      Amount: amtBeforeTax ?? 0,
      DocAmtBeforeTax: amtBeforeTax ?? 0,
      ...(docNoChecker === false ? { DocNo: data.DocNo } : null),
      CreditorAccountID: data?.CreditorAccountID,
      // debtor_account_id: data?.DebtorAccountID || null,
      Remark: data?.Remark,
      Description: data?.Description,
      // RefTable: creditDebitRefTable,
      ...(watch('CreditDebitID') ? { RefRecordID: data?.CreditDebitID } : null),
      RefNo: data?.RefNo,
      einvoice_irbm_uniqueID: data?.UIN,
      einvoice_self_billed: isSelfBilled,
      ...(isSelfBilled ? { einvoice_msic_code_id: msicCodeID } : null),
      einvoice_is_refund_note: isRefundNote,
      ApprovalStatus: statusInput(status),
      Attachment: files,
    }
  }

  // //To calculate Total Amount of Credit Note
  let totalAmount = creditNoteItemData?.reduce(
    (total, currentValue) => (total = total + currentValue.DocAmt),
    0
  )
  // //To calculate Total Amount of Credit Note
  let totalTaxAmt = creditNoteItemData?.reduce(
    (total, currentValue) => (total = total + currentValue.TaxAmt),
    0
  )

  // // get amount before tax
  let amtBeforeTax = totalAmount - totalTaxAmt
  let calcTotal = items => {
    return items?.reduce(
      (total, currentValue) => (total = total + currentValue.DocAmt),
      0
    )
  }

  const handleCreditorChange = event => {
    setSelectedDocs(new Set())
    remove()
    let selfBilled = creditorAcc?.find(
      x => x?.CreditorAccountID === event
    )?.einvoice_self_billed
    //to auto set msic code upon select creditor because this query will render allocation based on creditor
    let msicCodeID = creditorAcc?.find(
      x => x?.CreditorAccountID === event
    )?.einvoice_msic_code_id

    // FIX: Make sure the field is registered BEFORE setting value
    register('MSICCodeID')

    // FIX: Use '' instead of null to avoid yup type error
    // and pass shouldValidate: false to prevent immediate validation
    setValue('MSICCodeID', msicCodeID || '', { shouldValidate: false })

    // Update local state
    setMsicCodeID(msicCodeID || '')

    // Clear any previous errors
    clearErrors('MSICCodeID')

    if (
      new Date(watch('DocDate')).toISOString() <
        curEinvCompStart[0]?.eInvStartDate ||
      curEinvCompStart[0]?.EInvoiceStarted === false
    )
      setIsSelfBilled(false)
    else {
      register('isSelfBilled')
      setValue('isSelfBilled', selfBilled, { shouldValidate: false })
      setIsSelfBilled(selfBilled)
    }
    loadAllocationDocument({
      variables: {
        ...(editData && editData?.CreditorAccountID === event
          ? { entityID: [ID] }
          : null),
        creditorDebtorID: event,
        companyID: CompanyID,
        refTable: refTable,
        skip: 0,
        take: 20,
      },
    })
    fetchValidatedDocRef({
      variables: {
        CompanyID: CompanyID,
        CreditorAccountID: event,
      },
    })
  }

  let selfBilled = creditorAcc?.find(
    x => x?.CreditorAccountID === watch('CreditorAccountID')
  )?.einvoice_self_billed

  //this is for toggle self bill e-invoice
  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue('isSelfBilled', e.target.checked)
    setIsSelfBilled(e.target.checked)
  }

  const [selectedGRTNs, setSelectedGRTNs] = useState<Set<any>>(new Set([]))

  const handleCheckBoxChange = (event: any) => {
    let temp = selectedGRTNs || new Set()
    if (event?.target?.checked) {
      temp.add(event?.target?.value)
      setSelectedGRTNs(new Set(temp))
      fetchGRTNItem({ variables: { GRTNHeaderID: Array.from(selectedGRTNs) } })
    } else {
      temp.delete(event?.target?.value)
      setSelectedGRTNs(new Set(temp))
    }
    fetchGRTNItem({ variables: { GRTNHeaderID: Array.from(selectedGRTNs) } })
  }

  const getTotalAmt = () => {
    if (creditNoteItemData?.length > 0) {
      return creditNoteItemData.reduce((prevValue, currValue) => {
        return prevValue + currValue?.DocAmt
      }, 0)
    } else {
      return 0
    }
  }
  const getAllocationTotal = () => {
    if (watch('Allocation')?.length > 0) {
      return watch('Allocation').reduce((prevValue, currValue) => {
        return prevValue + currValue?.AllocationAmt
      }, 0)
    } else {
      return 0
    }
  }

  const getBalanceAmt = () => {
    if (watch('Allocation')?.length > 0) {
      return watch('Allocation')?.reduce((prevValue, currValue) => {
        return prevValue + currValue?.BalanceAmt
      }, 0)
    } else {
      return 0
    }
  }

  const docAmtChecker = () => {
    if (getTotalAmt > getBalanceAmt) {
      return true
    } else {
      return false
    }
  }
  const readOnly = () => {
    if (menu?.obj?.DOItemID || menu?.obj?.GRTNItemID) return true
    else return false
  }

  /* -------------------------------------------- */
  /*                USE EFFECT                    */
  /* -------------------------------------------- */

  useEffect(() => {
    if (ID && editData?.Remark) {
      setValue('Remark', editData?.Remark)
    }
  }, [editData])

  useEffect(() => {
    setRefresh(true)
    if (mode === 'edit') {
      setValue('CreditorAccountID', editData?.CreditorAccountID)
      fetchGetCreditorAccountCompanyAssignmentPaginatedListing({
        variables: {
          CompanyID,
          CreditorAccountID: editData?.CreditorAccountID,
        },
      })
    } else {
      setValue('CreditorAccountID', null)
      fetchGetCreditorAccountCompanyAssignmentPaginatedListing()
    }
  }, [])
  //   this is where i get the data for item when editing the form

  useEffect(() => {
    if (formMode === 'edit' && editData) {
      fetchGeneralGRTN({
        variables: {
          CreditorAccountID: editData?.CreditorAccountID,
          CompanyID,
          GRTNItemIDs: editData?.APCreditorCreditNoteItem?.filter?.(
            y => y?.GRTNItemID !== null
          )?.map(z => z?.GRTNItemID),
        },
      })
      const creditNoteItems = editData?.[itemRefTable]?.map((el, index) => {
        return {
          Sequence: el?.Sequence ?? index + 1,
          ...(docType === 'creditor-credit-note'
            ? {
                CreditorCreditNoteItemID: el?.CreditorCreditNoteItemID,
              }
            : {
                CreditNoteItemID: el?.CreditNoteItemID,
              }),
          ...(docType === 'creditor-credit-note'
            ? {
                GRTNItemID: el?.GRTNItemID,
              }
            : null),
          ExpenseItemName: el?.ExpenseItem?.ItemName,
          ExpenseItemID: el?.ExpenseItemID,
          CostCentreCode: el?.CostCentre?.Code,
          CostCentreID: el?.CostCentreID,
          Amount: el?.Amount,
          Quantity: Number(parseFloat(el?.Quantity).toFixed(4)),
          UnitPrice: Number(parseFloat(el?.UnitPrice).toFixed(4)),
          UOMID: el?.UOMID,
          TaxSchemeID: el?.TaxSchemeID,
          TaxCode: el?.TaxScheme?.Name,
          TaxAmt: el?.TaxAmt,
          Remark: el?.Remark ?? el?.Remarks ?? '-',
          DocAmt: el?.Amount + el?.TaxAmt,
          Description: '-',
          ItemTaxInfo: el?.ItemTaxInfo,
          einvoice_classification_code_id: el?.einvoice_classification_code_id,
          ClassificationCode: el?.ClassificationCode?.classificationCode,
          ClassificationDescription: el?.ClassificationCode?.description,
          DebtorAccountID: el?.debtor_account_id,
          SalesOrderID: el?.sales_order_id,
          TaxExemptionReason: el?.TaxExemptionReason
            ? el?.TaxExemptionReason
            : null,
          TaxExemptionAmount: el?.TaxExemptionAmount
            ? el?.TaxExemptionAmount
            : null,
          TaxExemptionRate: el?.TaxExemptionRate ? el?.TaxExemptionRate : null,
        }
      })

      creditNoteItemData.push(...creditNoteItems)
      if (editData?.GRTN?.length > 0) {
        editData?.GRTN?.map(x => selectedGRTNs.add(x?.GRTNHeaderID))
      }
    }
  }, [formMode, editData])

  /* -------------------------------------------- */
  /*                   DELETE                     */
  /* -------------------------------------------- */

  const onDeleteCreditNoteItem = (delInd: number) => {
    creditNoteItemData.splice(delInd, 1)
  }

  /* ------------------------------------------- */
  /*                ON SUBMIT                    */
  /* ------------------------------------------- */

  const onSubmit = (data, status) => {
    if (checkSetupNumStruc() === true) {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.errorNumberingStructure())
    }
    if (
      docType === 'creditor-credit-note' &&
      findDuplicates(existingDocNo) === true
    ) {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.duplicateDocNo())
    } else {
      if (
        isEinvoice &&
        curCompany[0]?.ConsolidatedLimitDetail &&
        !!!isSelfBilled &&
        !!!selectedCreditor[0]?.einvoice_send_individually
      ) {
        let curConsolidatedLimit =
          curCompany[0]?.ConsolidatedLimitDetail[0]?.Amount
        let curConsolidatedDate =
          curCompany[0]?.ConsolidatedLimitDetail[0]?.EffectiveDate

        for (const detail of curCompany[0]?.ConsolidatedLimitDetail) {
          if (new Date(data.TrxDate) >= new Date(detail?.EffectiveDate)) {
            curConsolidatedLimit = detail?.Amount
            curConsolidatedDate = detail?.EffectiveDate
          } else {
            break
          }
        }

        if (totalAmount > curConsolidatedLimit) {
          setErrMsg(
            `Total amount cannot exceed the company's allocation limit of ${amtStr(
              curConsolidatedLimit
            )} effective ${formatDate(curConsolidatedDate)}`
          )
          setErrorDia(true)
          setIsSubmit(false)
          return
        }
      }
      //add the data with GraphQL mutation
      handleMutation({
        variables: {
          input: inputData(data, status),
          itemInput:
            creditNoteItemData?.map(x => {
              const itemTaxInput =
                x?.ItemTaxInfo && x.ItemTaxInfo.length > 0
                  ? x.ItemTaxInfo.map(tax => ({
                      tax_amt: tax.taxAmt,
                      tax_rate: tax.taxRate,
                      tax_id: tax.taxId,
                      tax_scheme_detail_id: tax.taxSchemeDetailId,
                      tax_scheme_id: tax.taxSchemeId,
                    }))
                  : []

              return {
                ...(docType === 'creditor-credit-note'
                  ? {
                      CreditorCreditNoteID: ID,
                    }
                  : {
                      CreditNoteID: ID,
                    }),
                ...(docType === 'creditor-credit-note'
                  ? {
                      GRTNItemID: x?.GRTNItemID,
                    }
                  : null),
                ItemID: x?.CreditItemID,
                ExpenseItemID: x?.ExpenseItemID,
                Amount: parseFloat(x?.Amount),
                Quantity: Number(parseFloat(x?.Quantity).toFixed(4)),
                UnitPrice: Number(parseFloat(x?.UnitPrice).toFixed(4)),
                UOMID: x?.UOMID,
                TaxSchemeID: x?.TaxSchemeID,
                TaxAmt: parseFloat(x?.TaxAmt),
                DocAmt: Number(x?.DocAmt),
                CostCentreID: x?.CostCentreID,
                Remark: x?.Remark,
                // only APCreditorCreditNoteItemInput defines these fields
                ...(docType === 'creditor-credit-note'
                  ? {
                      debtor_account_id: x?.DebtorAccountID,
                      sales_order_id: x?.SalesOrderID,
                    }
                  : null),
                Sequence: x?.Sequence,
                itemTaxInput: itemTaxInput,
                einvoice_classification_code_id:
                  x?.einvoice_classification_code_id,
                TaxExemptionReason: x?.TaxExemptionReason ?? null,
                TaxExemptionAmount: x?.TaxExemptionAmount ?? null,
                TaxExemptionRate: x?.TaxExemptionRate ?? null,
              }
            }) ?? [],
          allocationInput:
            watch('Allocation')
              ?.filter(
                alloc =>
                  Number(alloc?.AllocationAmt) !== 0 || alloc?.AllocationID
              )
              ?.map(x => {
                const mainCreditOrDebit =
                  x?.CreditOrDebit === 'Debit' ? 'Credit' : 'Debit'
                return {
                  ...(x?.AllocationID
                    ? { AllocationID: x?.AllocationID }
                    : null),
                  AllocationAmt: Number(x?.AllocationAmt),
                  CreditOrDebit: x?.CreditOrDebit,
                  CompanyID: CompanyID,
                  // for allocated table
                  [`${x?.CreditOrDebit}RefTable`]:
                    x?.[`${x?.CreditOrDebit}RefTable`],
                  [`${x?.CreditOrDebit}ID`]: x?.[`${x?.CreditOrDebit}ID`],
                  // main table
                  [`${mainCreditOrDebit}RefTable`]: refTable,
                }
              }) ?? [],
          docRefInput: isSelfBilled
            ? Array.from(selectedDocs).map(doc => ({
                DocRefID: doc,
              }))
            : [],
        },
      })
    }
  }

  const docDateTimestamp = new Date(watch('DocDate'))
  const yearDocDate = docDateTimestamp.getFullYear()
  const monthDocDate = (docDateTimestamp.getMonth() + 1)
    .toString()
    .padStart(2, '0')
  const dayDocDate = docDateTimestamp.getDate().toString().padStart(2, '0')

  const transferDate = `${yearDocDate}-${monthDocDate}-${dayDocDate}`

  const trxDateTimestamp = new Date(watch('TrxDate'))
  const yearTrxDate = trxDateTimestamp.getFullYear()
  const monthTrxDate = (trxDateTimestamp.getMonth() + 1)
    .toString()
    .padStart(2, '0')
  const dayTrxDate = trxDateTimestamp.getDate().toString().padStart(2, '0')

  const trxDate = `${yearTrxDate}-${monthTrxDate}-${dayTrxDate}`

  const openPeriod1 =
    transferDate <= latestOpenPeriodCheckingDate?.StartDate ||
    transferDate >= latestOpenPeriodCheckingDate?.EndDate

  const openPeriod2 =
    trxDate >= latestOpenPeriodCheckingDate?.StartDate &&
    trxDate <= latestOpenPeriodCheckingDate?.EndDate

  const checkingYearClose1 = openPeriod1 ? true : false
  const checkingYearClose2 = openPeriod2 ? false : true

  const createUpdateCalled = mutationCalled

  /** This is for permission purposes */
  const { handlePermDisabled } = usePermissionChecker()

  const loading = getItemByCompany
    ? ExpenseItemLoading
    : getCostCentre
      ? CostCentreLoading
      : ''

  /* -------------------------------------------- */
  /*               DOC DATE VALIDATION            */
  /* -------------------------------------------- */
  const DocDate = watch('DocDate') ? new Date(watch('DocDate')) : null
  const today = new Date()

  const monthsBefore = getDocumentDateValidation?.[0]?.MonthsBefore ?? 12
  const monthsAfter = getDocumentDateValidation?.[0]?.MonthsAfter ?? 1

  // Calculate valid range
  const minValidDate = new Date(today)
  minValidDate.setMonth(minValidDate.getMonth() - monthsBefore)
  minValidDate.setHours(0, 0, 0, 0)

  const maxValidDate = new Date(today)
  maxValidDate.setMonth(maxValidDate.getMonth() + monthsAfter)
  maxValidDate.setHours(23, 59, 59, 999)

  // Validate inclusive range
  const isDocDateInvalid =
    DocDate &&
    (DocDate.getTime() < minValidDate.getTime() ||
      DocDate.getTime() > maxValidDate.getTime())

  /* -------------------------------------------- */
  /*                    FOOTER                    */
  /* -------------------------------------------- */
  const draftFooterOption = {
    name: 'Save as Draft',
    onClick: () => {
      handleSubmit(data => !createUpdateCalled && onSubmit(data, 'draft'))()
    },
    color: 'primary',
    props: {
      type: 'submit',
    },
    disabled:
      checkingYearClose2 ||
      isDocDateInvalid ||
      handlePermDisabled({
        companyID: CompanyID,
        permEnum:
          docType === 'creditor-credit-note'
            ? AcctPermission.AccPayableCreditorCreditNotesDraft
            : AcctPermission.AccPayableCreditNotesDraft,
      })
        ? true
        : false,
  }

  const rejectFooterOption = {
    name: 'Save',
    onClick: () => {
      handleSubmit(data => !createUpdateCalled && onSubmit(data, 'reject'))()
    },
    color: 'primary',
    props: {
      type: 'submit',
    },
    disabled:
      !!errors?.DocDate ||
      !!errors?.TrxDate ||
      !!errors?.RefNo ||
      !!errors?.CreditorAccountID ||
      !!errors?.Description ||
      checkingYearClose2 ||
      isDocDateInvalid
        ? true
        : handlePermDisabled({
              companyID: CompanyID,
              permEnum:
                docType === 'creditor-credit-note'
                  ? AcctPermission.AccPayableCreditorCreditNotesUpdate
                  : AcctPermission.AccPayableCreditNotesUpdate,
            })
          ? true
          : false,
  }

  const submitFooterOption = {
    name: 'Submit',
    onClick: e => {
      setIsSubmit(true)
      handleSubmit(data => !createUpdateCalled && onSubmit(data, 'submit'))()
    },
    color: 'primary',
    props: {
      type: 'submit',
    },
    disabled:
      calcTotal(creditNoteItemData) === 0 ||
      calcTotal(creditNoteItemData) === undefined ||
      checkingYearClose2 === true ||
      isDocDateInvalid ||
      (getAllocationTotal() !== calcTotal(creditNoteItemData) && isSelfBilled)
        ? true
        : false,
  }

  let footerOptions: any[]
  if (editData?.mode === 'resubmit') {
    footerOptions = [rejectFooterOption, submitFooterOption]
  } else {
    footerOptions = [draftFooterOption, submitFooterOption]
  }

  /* -------------------------------------------- */
  /*               EXIT CONFIRMATION              */
  /* -------------------------------------------- */

  const hasChanges = () =>
    handleExitConfirmation({
      watch: watch,
      editData: editData,
      formMode: formMode,

      // for item
      itemSuffixID: itemRefTableKey,
      itemTableName: itemRefTable,
      // for attachment
      initFiles: initDocs,
      currFiles: files?.map(file => file?.name),
    })

  useEffect(() => {
    if (openItemDialog) {
      localStorage.setItem(
        'creditNote',
        JSON.stringify({
          DocDate: getValues('DocDate'),
        })
      )
    } else {
      localStorage.removeItem('creditNote')
    }
  }, [openItemDialog, getValues])

  const creditNoteHeader = JSON.parse(localStorage.getItem('creditNote'))

  return (
    <>
      {loading && <Loading />}
      {CompanyLoading && <Loading />}
      {documentLoading && <Loading />}
      {mutationLoading && <Loading />}
      {ItemGRTNsLoading && <Loading />}
      {SalesOrderLoading && <Loading />}
      {docNumHeaderLoading && <Loading />}
      {DebtorAccountLoading && <Loading />}
      {EinvCompStartLoading && <Loading />}
      {DocDateValidationLoading && <Loading />}
      {openPeriodCheckDateLoading && <Loading />}
      {FetchGetCreditorAccountCompanyAssignmentPaginatedLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => {
          {
            if (hasChanges() === true) {
              setOpenExitConf(true)
            } else {
              history.push({
                pathname: `/account-payable/${CompanyID}/${docType}`,
              })
            }
          }
        }}
        smTitle={'Account Payable'}
        title={curCompany[0]?.Name}
        routeSegments={[
          { name: 'Accounts Payable Main Menu' },
          { name: 'Accounts Payable Submenu' },
          { name: routeSegments, current: true },
        ]}
        rightRouteSegments={[
          {
            name:
              formMode === 'add'
                ? 'New'
                : formMode === 'approve-reject'
                  ? 'Approve/Reject'
                  : formMode === 'edit'
                    ? 'Edit'
                    : 'Draft',
            current: true,
          },
        ]}
      />
      <ContentWrapper footer float>
        <InfiniteScroll
          scrollableTarget="scroll-wrapper"
          dataLength={fields.length}
          next={() => {
            if (creditorAccID) {
              loadAllocationDocument({
                variables: {
                  entityID: editData ? [ID] : null,
                  companyID: CompanyID,
                  refTable: refTable,
                  skip: skip,
                  take: take,
                  creditorDebtorID: creditorAccID,
                },
              })
            }
          }}
          hasMore={hasMore}
          loader={
            getAllocationDocumentLoading && (
              <div style={{ textAlign: 'center' }}>
                <CircularProgress />
              </div>
            )
          }
        >
          <CardContents
            section={{
              header: {
                title: (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <span>{`${routeSegments}`}</span>
                    {formMode === 'edit' && (
                      <IconText
                        icon={
                          <img
                            src={AuditLog}
                            style={{
                              width: '17px',
                              marginLeft: '12px',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              history.push({
                                pathname: `/account-payable/${CompanyID}/credit-note/${ID}/detail/audit-log`,
                                state: {
                                  ID: editData?.ID,
                                  tableName: refTable,
                                  primaryKey: primaryKey,
                                  primaryItemKey: 'CreditNoteItemID',
                                  ...editData,
                                },
                              })
                            }}
                          />
                        }
                        font="desc"
                      />
                    )}
                  </div>
                ),
              },
            }}
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Controller
                as={KeyboardDatePicker}
                name="DocDate"
                required
                label="Doc Date"
                control={control}
                format="dd/MM/yyyy"
                margin="normal"
                allowKeyboardControl
                onChange={(date: Date | null) => {}}
                onAccept={(date: Date | null) => {
                  fetchEinvComp({
                    variables: {
                      CompanyID: CompanyID,
                      RecordStatus: RecordStatus.Active,
                      DocDate: date,
                    },
                  })
                  let selfBilled = creditorAcc?.find(
                    x => x?.CreditorAccountID === watch('CreditorAccountID')
                  )?.einvoice_self_billed
                  let defaultMsicCodeID = creditorAcc?.find(
                    x => x?.CreditorAccountID === watch('CreditorAccountID')
                  )?.einvoice_msic_code_id
                  if (
                    new Date(date).toISOString() <
                    curEinvCompStart[0]?.eInvStartDate
                  )
                    setIsSelfBilled(false)
                  else {
                    register('isSelfBilled')
                    setValue('isSelfBilled', selfBilled)
                    setIsSelfBilled(selfBilled)
                    setValue('MSICCodeID', defaultMsicCodeID)
                    setMsicCodeID(defaultMsicCodeID)
                  }
                }}
                ref={register}
                KeyboardButtonProps={{ 'aria-label': 'change date' }}
                showTodayButton
                className={'left'}
                value={watch(
                  formMode === 'add' ? new Date() : editData?.DocDate
                )}
                defaultValue={editData ? editData?.DocDate : new Date()}
                minDate={minValidDate}
                maxDate={maxValidDate}
                helperText={
                  isDocDateInvalid
                    ? 'Document date is not within the validation range'
                    : errors?.DocDate?.message
                }
                error={!!errors?.DocDate || isDocDateInvalid}
              />
            </MuiPickersUtilsProvider>

            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Controller
                as={KeyboardDatePicker}
                name="TrxDate"
                required
                label="Transaction Date"
                control={control}
                format="dd/MM/yyyy"
                margin="normal"
                allowKeyboardControl
                onChange={(date: Date | null) => {}}
                ref={register}
                KeyboardButtonProps={{ 'aria-label': 'change date' }}
                showTodayButton
                className="right"
                value={new Date()}
                defaultValue={editData ? editData?.TransactionDate : new Date()}
                minDate={new Date(latestOpenPeriodCheckingDate?.StartDate)}
                maxDate={new Date(latestOpenPeriodCheckingDate?.EndDate)}
                helperText={
                  checkingYearClose2
                    ? 'Financial Period already closed'
                    : errors?.TrxDate?.message
                }
                error={errors?.TrxDate || checkingYearClose2 ? true : false}
              />
            </MuiPickersUtilsProvider>

            {(docNoChecker === false && docType === 'creditor-credit-note') ||
            (getDocumentNumberHeader[0]?.IsAutoDocNo === false &&
              refTable === 'creditor-credit-note') ? (
              <Controller
                as={TextField}
                name="DocNo"
                label="Document No"
                margin="dense"
                required
                id="standard-basic"
                defaultValue={editData?.DocNo}
                autoComplete="off"
                control={control}
                className="left"
                ref={register}
                helperText={errors?.DocNo?.message}
                error={errors?.DocNo ? true : false}
              />
            ) : null}

            <Controller
              as={TextField}
              id="standard-basic"
              name="RefNo"
              label="Reference No."
              required
              autoComplete="off"
              control={control}
              className={
                (docNoChecker === false &&
                  docType === 'creditor-credit-note') ||
                (getDocumentNumberHeader[0]?.IsAutoDocNo === false &&
                  docType === 'creditor-credit-note')
                  ? 'right'
                  : ''
              }
              fullWidth={
                (docNoChecker === false &&
                  docType === 'creditor-credit-note') ||
                (getDocumentNumberHeader[0]?.IsAutoDocNo === false &&
                  docType === 'creditor-credit-note')
                  ? true
                  : false
              }
              margin="dense"
              ref={register}
              helperText={errors?.RefNo?.message}
              error={errors?.RefNo ? true : false}
              defaultValue={editData ? editData?.RefNo : ''}
              disabled={mode == 'approve-reject'}
            />

            <Controller
              as={TextField}
              id="standard-basic"
              name="UIN"
              label="UIN"
              // required
              autoComplete="off"
              control={control}
              fullWidth
              margin="dense"
              ref={register}
              helperText={errors?.UIN?.message}
              error={errors?.UIN ? true : false}
              defaultValue={editData ? editData?.einvoice_irbm_uniqueID : ''}
            />

            {!refresh && (
              <Controller
                name="CreditorAccountID"
                ref={register()}
                control={control}
                defaultValue={editData?.CreditorAccountID}
                render={({ onChange, value }) => {
                  const selectedItem = creditorAccounts?.find(
                    item =>
                      item?.CreditorAccountID === watch('CreditorAccountID')
                  )
                  return (
                    <PaginatedAutocomplete
                      required
                      label="Creditor Name"
                      searchVariable="searchValue"
                      fetchMoreOptions={
                        fetchGetCreditorAccountCompanyAssignmentPaginatedListing
                      }
                      setOptions={setCreditorAccounts}
                      options={creditorAccounts || []}
                      totalLength={totalCreditorAccounts}
                      setValue={setValue}
                      name="CreditorAccountID"
                      optionsLoading={
                        FetchGetCreditorAccountCompanyAssignmentPaginatedLoading
                      }
                      getOptionLabel={option => `${option?.CompanyName}`}
                      fullWidth
                      value={selectedItem}
                      onChange={(event, newValue) => {
                        setRefresh(false)

                        if (!newValue || !newValue?.CreditorAccountID) {
                          setValue('CreditorAccountID', null)
                          setCreditorAccID(null)
                          return
                        }

                        setValue(
                          'CreditorAccountID',
                          newValue?.CreditorAccountID
                        )
                        setCreditorAccID(newValue?.CreditorAccountID)
                        handleCreditorChange(newValue?.CreditorAccountID)
                        onChange(newValue?.CreditorAccountID)
                      }}
                      renderOption={(props, option) => {
                        return <span>{props?.CompanyName}</span>
                      }}
                    />
                  )
                }}
              />
            )}

            {docType === 'creditor-credit-note' && !GeneralGRTNLoading && (
              <Controller
                render={({ value, onChange }) => {
                  return (
                    <Autocomplete
                      multiple
                      disableCloseOnSelect
                      options={
                        getGeneralGRTN?.sort((a, b) => {
                          return a.DocNo.localeCompare(b.DocNo)
                        }) || []
                      }
                      getOptionLabel={option => `${option?.DocNo}`}
                      fullWidth
                      onChange={(event, value, reason) => {
                        // Create a new Set from the current selected items
                        const updatedSelected = new Set(selectedGRTNs)

                        if (reason === 'remove-option') {
                          // Clear the Set and add only remaining selected items
                          updatedSelected.clear()
                          value?.forEach(x => {
                            updatedSelected.add(x?.GRTNHeaderID)
                          })
                        } else if (reason === 'clear') {
                          // Reset everything
                          updatedSelected.clear()
                          setCreditNoteItemData([])
                        } else {
                          // Normal selection process
                          value?.forEach(x =>
                            updatedSelected.add(x?.GRTNHeaderID)
                          )
                        }

                        // Update state with a new Set instance
                        setSelectedGRTNs(new Set(updatedSelected))

                        // Ensure fetchGRTNItem is called with the latest selected IDs
                        fetchGRTNItem({
                          variables: {
                            GRTNHeaderID: Array.from(updatedSelected),
                          },
                        })
                      }}
                      defaultValue={editData?.GRTN}
                      renderOption={(option, { selected }) => (
                        <Fragment>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            value={option?.GRTNHeaderID}
                            style={{ marginRight: 8 }}
                            checked={selectedGRTNs.has(option?.GRTNHeaderID)}
                            color="primary"
                            onChange={event => {
                              handleCheckBoxChange(event)
                            }}
                          />
                          <ListItemText
                            primary={
                              <Grid container>
                                <Grid
                                  item
                                  xs={8}
                                  component="span"
                                  className="xsTitle "
                                >
                                  {option?.DocNo}
                                </Grid>
                                <Grid
                                  item
                                  xs={4}
                                  component="span"
                                  className="xsTitle right-text highlight-text"
                                >
                                  {amtStr(option?.ReturnedAmt)}
                                </Grid>
                              </Grid>
                            }
                            secondary={
                              <Grid container>
                                <Grid
                                  item
                                  xs={8}
                                  component="span"
                                  className="desc"
                                  style={{
                                    wordWrap: 'break-word',
                                    wordBreak: 'break-word',
                                    whiteSpace: 'pre-wrap',
                                  }}
                                >
                                  {option?.PONo}
                                </Grid>
                                <Grid
                                  item
                                  xs={4}
                                  component="span"
                                  className="xsTitle right-text highlight-text"
                                ></Grid>
                              </Grid>
                            }
                          />
                        </Fragment>
                      )}
                      renderInput={(params: any) => {
                        return (
                          <div>
                            <TextField
                              {...params}
                              variant="outlined"
                              style={{ width: '100%' }}
                              label="GRTN No."
                              margin="normal"
                              onKeyDown={(event: any) => {
                                if (event.key === 'Backspace') {
                                  event.stopPropagation()
                                  setSelectedGRTNs(new Set())
                                }
                              }}
                            />
                          </div>
                        )
                      }}
                    />
                  )
                }}
                name="GRTNHeaderID"
                label="GRTN No."
                margin="normal"
                autoComplete="off"
                fullWidth
                multiline={true}
                control={control}
                select
                ref={register}
              />
            )}

            <Controller
              as={TextField}
              id="standard-basic"
              name="Description"
              label="Description"
              required
              autoComplete="off"
              control={control}
              fullWidth
              margin="dense"
              helperText={errors?.Description?.message}
              error={errors?.Description ? true : false}
              defaultValue={editData?.Description}
              ref={register}
              disabled={mode === 'approve-reject'}
              multiline
            />

            <VoiceTextField
              mounted={true}
              label="Remark"
              name="Remark"
              value={voiceRemark}
              setValue={setValue}
              record={record}
              setRecord={setRecord}
              control={control}
              controllerProps={{
                error: errors?.Remark ? true : false,
                helperText: errors?.Remark?.message,
                ref: register,
                autoComplete: 'off',
              }}
            />

            {isEinvoice && (
              <IsEinvoiceSelfBilled
                register={register}
                control={control}
                errors={errors}
                selfBilled={selfBilled}
                defaultMsicCodeID={defaultMsicCodeID}
                isSelfBilled={isSelfBilled}
                handleToggle={handleToggle}
                setIsRefundNote={setIsRefundNote}
                isRefundNote={isRefundNote}
                msicCodeLoading={msicCodeLoading}
                getMSICCode={getMSICCode}
                msicCodeID={msicCodeID}
                setMsicCodeID={setMsicCodeID}
                selfBilledChecking={!!selfBilled}
                haveSelfBilled={
                  !!selfBilled && !!watch('isSelfBilled') && !msicCodeLoading
                }
                data={getAPValidatedDocRef}
                dataLoading={APValidatedDocRefLoading}
                isDocRefID={!!watch('isSelfBilled') && !msicCodeLoading}
                docRefKeyID={'DocRefID'}
                editData={editData}
                selectedDocs={selectedDocs}
                setSelectedDocs={setSelectedDocs}
                clearErrors={clearErrors}
                setValue={setValue}
                isCN={!!selfBilled && !!watch('isSelfBilled')}
              />
            )}

            <div style={{ width: '100%', marginTop: '24px' }}>
              <FileUploadInput
                placeholder={previewFiles.length === 0 ? 'Attachment' : null}
                label={previewFiles.length > 0 ? 'Attachment' : null}
                name="Attachment"
                files={files}
                onHandleUploadChange={handleUploadChange}
                multiple
                accept={
                  '.png, .jpg, .jpeg, .gif, .mp4, .avi, .mkv, .mov, .flv, .3gp, application/msword, application/pdf, application/vnd.ms-excel, application/*, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                }
                imagePreview={
                  <>
                    {previewFiles?.map((v, i) => (
                      <UploadPreview
                        remove
                        key={v}
                        src={v}
                        onClick={() => removeFile(i)}
                        mediaType={
                          files[i]?.type ??
                          DocData?.DocumentListing[i]?.mediaType
                        }
                      />
                    ))}
                  </>
                }
              />
            </div>
          </CardContents>

          <ItemDetail
            CN={true}
            titleLabel={'Charge to'}
            itemData={creditNoteItemData}
            setOpenDialog={setOpenItemDialog}
            fetchExpenseItem={fetchExpenseItem}
            fetchCostCentre={fetchCostCentre}
            resetMenu={resetMenu}
            setSelectedTax={setSelectedTax}
            setDetailMode={setDetailMode}
            formMode={formMode}
            detailMode={detailMode}
            getItemByCompany={expenseItemListing}
            getCostCentre={getCostCentre}
            handleClick={handleClick}
            keyItemID={itemRefTableKey}
            isSelfBilled={isSelfBilled}
            creditorID={selectedCreditor}
          />

          {watch('CreditorAccountID') && (
            <FormAllocationTableContent
              headerLeftTitle={'Allocation'}
              fields={fields}
              watch={watch}
              errors={errors}
              register={register}
              control={control}
              setValue={setValue}
              clearErrors={clearErrors}
              setError={setError}
              allocatedObj={allocatedObj}
              docAmt={getTotalAmt()}
              totalAmt={getAllocationTotal()}
              headerStyle={{
                backgroundColor: '#faf2e8',
                color: '#ff9800',
                fontWeight: '700',
              }}
              hasCheckbox={true}
              companyID={CompanyID}
            />
          )}
        </InfiniteScroll>
      </ContentWrapper>

      <Menu
        id="menu-list"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        <MenuItem
          onClick={() => {
            !expenseItemListing?.find(
              x => x?.ExpenseItemID === menu?.obj?.ExpenseItemID
            ) &&
              fetchExpenseItem({
                variables: {
                  CompanyID,
                  ExpenseItemID: menu?.obj?.ExpenseItemID,
                },
              })
            setEdit(true)
            setOpenItemDialog(true)
            setDetailMode('edit')
          }}
        >
          <span className="">Edit</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            onDeleteCreditNoteItem(menu?.index)
          }}
          disabled={readOnly() === true ? true : false}
        >
          <span className="">Delete</span>
        </MenuItem>
      </Menu>

      {openItemDialog && (
        <ItemDialog
          getDebtorAccount={getDebtorAccountListing}
          DebtorAccountLoading={DebtorAccountLoading}
          editData={editData}
          fetchSalesOrder={fetchSalesOrder}
          title={'Charge to'}
          companyID={CompanyID}
          fromAP={true}
          openItemDialog={openItemDialog}
          setOpenItemDialog={setOpenItemDialog}
          watch={watch}
          menu={menu}
          ExpenseItemLoading={ExpenseItemLoading}
          fetchExpenseItem={fetchExpenseItem}
          getItemByCompany={expenseItemListing}
          isEdit={edit}
          itemData={creditNoteItemData}
          selectedTax={selectedTax}
          setSelectedTax={setSelectedTax}
          detailMode={detailMode}
          setDetailMode={setDetailMode}
          resetMenu={resetMenu}
          primaryItemKey={itemRefTableKey}
          selfBillStatus={isSelfBilled}
          EInvoiceStarted={isEinvoice}
          creditorAcc={selectedCreditor}
          fetchMoreOptions={fetchExpenseItem}
          setOptions={setExpenseItemListing}
          totalLength={totalLength}
          localData={creditNoteHeader}
          module={'APCreditNote'}
          getSalesOrderByDebtor={getSalesOrderByDebtor}
          SalesOrderLoading={SalesOrderLoading}
          docType={docType}
        />
      )}

      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(`/account-payable/${CompanyID}/${docType}`)
        }}
      />

      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error!'}
      />
      {footerOptions?.length > 0 ? (
        <Footer options={[...footerOptions]} />
      ) : null}

      <TooltipAmountFooter
        data={creditNoteItemData}
        module={`${docType}-draft`}
      />
    </>
  )
}
